export interface HomeAssignment {
  assignmentId: string;
  isDirectAssignment: boolean;
  mode: UserAssignmentsMode;
  title: string;
  titleShort?: string;
  maxAttempts?: number;
  thumbnail: string;
  progress: number;
  duration: string;
  dueDate: string;
  progressStatus: ProgressStatus;
  assignmentType: AssignmentType;
  courseCount: number;
  policyCount: number;
  surveyCount: number;
  isLocked?: boolean;
  prerequisites?: number;
}

export enum UserAssignmentsMode {
  PREVIEW = "preview",
  ENROLLED = "enrolled",
}

export enum ProgressStatus {
  NOTSTARTED = "Not-Started",
  INPROGRESS = "In-Progress",
  COMPLETED = "Completed",
  FAILED = "Failed",
  NOTSTARTED_OVERDUE = "Not-Started(Overdue)",
  INPROGRESS_OVERDUE = "In-Progress(Overdue)",
  FAILED_OVERDUE = "Completed(Overdue)",
}

export enum AssignmentType {
  COURSE = "course",
  POLICY = "policy",
  SURVEY = "survey",
}

export enum ImportanceType {
  REQUIRED = "required",
  OPTIONAL = "optional",
}

export interface GetHomeAssignmentsParams {
  portalGroupId?: string; // Not sent when groupLevel = 0
  groupLevel: number;
  type?: string;
  importance?: string;
  progressStatus?: string;
}

export interface UserAssignment {
  UserAssignmentUid: string;
  PortalAssignmentUid: string;
  Status: string;
  Progress: string;
  ProgressStatus: ProgressStatus;
  Bookmark: string;
  AssignmentVersionUid: string;
  AssignmentVersionId: number;
  RecordNo: number;
  AckResponse: string;
  Comment: string;
  SubmittedAt: string;
  AssignmentUid: string;
  Title: string;
  Acknowledgement: boolean;
  PageByPage: boolean;
  Mandatory?: boolean;
  Url: string;
  PackageType: string;
  Notes?: UserAssignmentNote[];
  MenuItems?: AssignmentMenuItem[];
  InteractionSession: string;
  Mode: UserAssignmentsMode;
}

export interface UserAssignmentQueryParams {
  mode: UserAssignmentsMode;
}

export interface UserAssignmentNote {
  UserAssignmentNoteUid: string;
  Note: string;
  IsMarkedForDelete: boolean;
  IsEdited: boolean;
  Datetime: string;
}

export interface AssignmentMenuItem {
  Title: string;
  PageNo: string;
  subchapters?: AssignmentMenuItem[];
}

export interface LogInteractionBody {
  interactionSession: string;
  interactionData: string;
  completionPercentage?: string;
  isTerminate?: boolean;
}

export interface CreateUpdateNoteBody {
  note: string;
  isDeleted: boolean;
}

export interface CreateUpdateNoteResponse {
  UserAssignmentNoteUid: string;
  Datetime: Date;
}

export interface UserAssignmentAcknowledgementBodyParams {
  ackResponse?: boolean;
  comment?: string;
}
